import { render, staticRenderFns } from "./MarcoNormativo.vue?vue&type=template&id=f037d3d8&"
import script from "./MarcoNormativo.vue?vue&type=script&lang=js&"
export * from "./MarcoNormativo.vue?vue&type=script&lang=js&"
import style0 from "./MarcoNormativo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports